import { Component, Input, inject } from '@angular/core';
import { BehaviorSubject, map, skipWhile } from 'rxjs';
import { ConversationDetail } from '../../../../../../../core/src/lib//interface/conversation.interface';
import { CONVERSATION_HOST_APP_INTERFACE_TOKEN } from '../../../../../../../core/src/lib/tokens';

const VMF_INSTANCE = 'https://vendasta-support.zendesk.com/agent/tickets/';

export type TicketInfo = {
  id: string;
  subject: string;
  description: string;
  status: string;
  requester: string;
  createdAt: string;
  channel: string;
  groupName: string;
  badgeColor: string;
  url: string;
  total: number;
};

@Component({
  selector: 'inbox-ticket',
  templateUrl: './inbox-ticket.component.html',
  styleUrls: ['./inbox-ticket.component.scss'],
  standalone: false,
})
export class InboxTicketComponent {
  private readonly hostAppInterface = inject(CONVERSATION_HOST_APP_INTERFACE_TOKEN);

  @Input() set conversationDetails(conversationDetail: ConversationDetail) {
    this.conversationSubject$$.next(conversationDetail);
  }

  private readonly conversationSubject$$ = new BehaviorSubject<ConversationDetail>(null);
  readonly partnerAccountGroupId$ = this.conversationSubject$$.asObservable().pipe(
    skipWhile((detail) => !detail),
    map((detail) => {
      return this.hostAppInterface.getConversationTitleInfo(detail).secondarySubtitle;
    }),
  );

  openCreateTicket() {
    window.open(VMF_INSTANCE.concat('new/1'), '_blank');
  }
}
